import React, { useCallback, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import AppLayout from "../components/Layout/AppLayout";
import DesktopHeader from "../components/Layout/Header/LandingHeader/DesktopHeader";
import MobileHeader from "../components/Layout/Header/DemoHeader/MobileHeader";
import SiteFooter from "../components/Layout/Footer/SiteFooter";
import CelebrationBanner from "../components/Celebration/CelebrationBanner";
import CelebrationVideoModal from "../components/Celebration/CelebrationVideoModal";
import CelebrationHero from "../components/Celebration/CelebrationHero";
import CelebrationStory from "../components/Celebration/CelebrationStory";
import CelebrationWhy from "../components/Celebration/CelebrationWhy";
import CelebrationValues from "../components/Celebration/CelebrationValues";
import CelebrationContact from "../components/Celebration/CelebrationContact";

export default function CelebrationPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const isWatchOpen = searchParams.get("watch") === "1";

  const lastTriggerRef = useRef(null);
  const heroPlayButtonRef = useRef(null);

  const openWatch = useCallback(
    (triggerEl) => {
      lastTriggerRef.current = triggerEl || null;
      const next = new URLSearchParams(searchParams);
      next.set("watch", "1");
      setSearchParams(next);
    },
    [searchParams, setSearchParams]
  );

  const handleBannerWatch = useCallback(
    (e) => {
      openWatch(e.currentTarget);
    },
    [openWatch]
  );

  const handleHeroPlay = useCallback(
    (triggerEl) => {
      openWatch(triggerEl);
    },
    [openWatch]
  );

  const handleModalClose = useCallback(() => {
    if (searchParams.get("watch") === "1") {
      const next = new URLSearchParams(searchParams);
      next.delete("watch");
      setSearchParams(next, { replace: true });
    }

    const target = lastTriggerRef.current;
    if (target && target.isConnected) {
      target.focus();
    } else {
      heroPlayButtonRef.current?.focus();
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className="celebration-scope">
      <AppLayout>
        <CelebrationBanner onWatch={handleBannerWatch} />
        <DesktopHeader />
        <MobileHeader />
        <CelebrationHero playButtonRef={heroPlayButtonRef} onPlay={handleHeroPlay} />
        <CelebrationStory />
        <CelebrationWhy />
        <CelebrationValues />
        <CelebrationContact />
        <SiteFooter />
        <CelebrationVideoModal isOpen={isWatchOpen} onClose={handleModalClose} videoId="NgOpc960J3I" />
      </AppLayout>
    </div>
  );
}
